export class XmlRequest {
    filename: string;
    
    constructor(){
        this.filename ="";
    }
}
